import { TASK_STATUS_FILTERS, type TaskStatusFilter } from '@pmai/contracts';
import { SelectField } from '@pmai/ui';
import { useTranslation } from 'react-i18next';

/** Visi / Nav pabeigti / Pabeigti (FR-TASK-013, FR-CUST-014). */
export function TaskStatusSelect({
  value,
  onChange,
}: {
  value: TaskStatusFilter;
  onChange: (value: TaskStatusFilter) => void;
}) {
  const { t } = useTranslation();
  return (
    <SelectField
      label={t('tasks.fields.status')}
      options={TASK_STATUS_FILTERS.map((s) => ({ value: s, label: t(`tasks.statusFilter.${s}`) }))}
      value={value}
      onChange={(e) => onChange(e.target.value as TaskStatusFilter)}
    />
  );
}
